// removed by extract-text-webpack-plugin
module.exports = {"clearfix":"style__clearfix___cf042","section":"style__section___35vC2"};


//////////////////
// WEBPACK FOOTER
// ./components/AccordionSection/style.scss
// module id = 1237
// module chunks = 0